import { Controller } from "@hotwired/stimulus"

export default class extends Controller {  
  connect() {
    this.generateThumbnail()
  }
  
  generateThumbnail() {
    const video = this.element
    let attempting = false
    
    const tryGenerateThumbnail = () => {
      if (attempting) return
      attempting = true
      
      // Wait a bit for video to be ready
      setTimeout(() => {
        if (video.videoWidth > 0 && video.videoHeight > 0) {
          try {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
            
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
            video.poster = canvas.toDataURL('image/jpeg', 0.7)
            
            console.log('Video thumbnail generated')
          } catch (error) {
            console.log('Could not generate thumbnail:', error)
          }
        }
        attempting = false
      }, 200)
    }
    
    // Multiple attempts to capture thumbnail
    video.addEventListener('loadedmetadata', () => {
      video.currentTime = 1 // Seek to 1 second
    })
    
    video.addEventListener('loadeddata', tryGenerateThumbnail)
    video.addEventListener('canplay', tryGenerateThumbnail)
    video.addEventListener('seeked', tryGenerateThumbnail)
  }
}